<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d--flex justify-content--space-between align-items--center">
        <dara-header>
          {{ $t('tracks') }}
          <el-tooltip effect="dark" :content="$t('some-tracks-may-not-appear-due-to-permission')" placement="right-end">
            <dara-icon size="lg" icon="info-circle-fill" class="ms-1" />
          </el-tooltip>
        </dara-header>
        <dara-button v-if="user.permission > 0" @click="onCreateTrack">
          {{ $t('add-track') }}
        </dara-button>
      </div>
      <table v-if="tracksList && tracksList.length > 0" class="table">
        <tbody>
          <tr v-for="track in tracksList" :key="track.id">
            <td class="py-3 px-2">
              <dara-header size="sm">
                <dara-track-link :id="track.id" :slug="track.slug">
                  {{ track.name }}
                </dara-track-link>
              </dara-header>
              <dara-p color="regular">
                {{ track.description }}
              </dara-p>
            </td>
            <td class="align-middle text-end">
              <el-dropdown v-if="canEdit(track)" trigger="click">
                <dara-icon
                  icon="three-dots-vertical"
                  class="cursor--pointer mx--md" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <dara-track-link
                      :id="track.id"
                      action="edit">
                      <dara-icon size="sm" icon="pencil" />
                      {{ $t('edit') }}
                    </dara-track-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <a @click="setDeleteTrack(track)">
                      <dara-icon size="sm" icon="trash" />
                      {{ $t('delete') }}
                    </a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <dara-modal-delete
                v-if="showModal(track)"
                :content="$t('are-you-sure-you-want-to-delete-this-track')"
                @close="setDeleteTrack(null)"
                @confirm="onDeleteTrack(track)">
              </dara-modal-delete>
            </td>
          </tr>
        </tbody>
      </table>
      <dara-p v-else class="opacity--50 my--lg">( {{ $t('no-tracks') }} )</dara-p>
      <dara-pagination
        :page.sync="pagination.page"
        :total="pagination.total"
        :page-size="pagination.limit"
        @current-change="fetch" />
    </template>
  </dara-single-content-layout>
</template>

<script>
import { goToCreateTrack } from '@/modules/track/track.routes';
import { fetchTracks, removeTrack } from '@/modules/track/track.service';
import { getters } from '@/modules/user/user.store';
import { USERS_ROLES } from '@/modules/user/user.constants';

import DaraTrackLink from '@/modules/track/components/TrackLink.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraMySpaceTracks',
  components: {
    DaraTrackLink,
    DaraSingleContentLayout,
  },
  data() {
    return {
      user: getters.getUser(),
      tracksList: [],
      trackDelete: null,
      pagination: {
        page: 1,
        limit: 5,
      },
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    canEdit(track) {
      return (this.user.permission > USERS_ROLES.WRITER || (track.user.id === this.user.id && this.user.permission > USERS_ROLES.READER));
    },
    fetch() {
      this.tracksList = [];
      fetchTracks(this.pagination)
        .then(data => {
          this.tracksList = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => {
          this.tracksList = [];
        });
    },
    setDeleteTrack(track) {
      this.trackDelete = track;
    },
    showModal(track) {
      return this.trackDelete && this.trackDelete.id === track.id;
    },
    onDeleteTrack(track) {
      removeTrack(track).then(() => this.$router.go(0));
    },
    onCreateTrack() {
      goToCreateTrack(this.$router);
    },
  },
};
</script>
